import { useSelector } from "react-redux"
import { MULTICINEMA } from "../constants/multiCinemaModes"
import getMomentDateObj from "./getMomentDateObj"
import getMomentNow from "./getMomentNow"
import filterPerformancesDateFilter from "./filterPerformancesDateFilter"
import getContainsIgnoredAttributes from "./getContainsIgnoredAttributes"
import setMomentDateObjZero from "./setMomentDateObjZero"
import filterPerformancesQueryStringValues from "./filterPerformancesQueryStringValues"
import isCurrentPerformance from "./isCurrentPerformance"

const getFullyFilteredPerformances = (performances, activeCinemaSet = null, technologyAttributes, queryStringValues, filterType, filterValue, overviewFilterIgnoreOnPerformances, dayFilters) => {
    const cliData = useSelector((state) => state.toJS().cliData)
    const apiData = useSelector((state) => state.toJS().apiData)
    const translation = useSelector((state) => state.toJS().translation)
    const {
        clusterCinemaOption,
        currentCinemaId
    } = cliData
    const {cinemas} = apiData
    const cinemaItems = cinemas.items
    const {timezone, locale} = translation

    let purchaseblePerformances = _.filter(performances, performance => {
        const {limitations} = performance

        if(limitations.visibleFrom) {
            const performanceDate = getMomentDateObj(limitations.visibleFrom, timezone)
            return getMomentNow(timezone).isAfter(performanceDate)
        } else {
            return true
        }
    })

    const today = setMomentDateObjZero(getMomentNow(timezone))
    let cinemaFilteredPerformances = purchaseblePerformances
    const currentCinema = currentCinemaId ? cinemaItems[currentCinemaId] : null
    const currentCinemaType = currentCinema ? currentCinema.scope.type : null
    const activeCinema = activeCinemaSet ? activeCinemaSet : currentCinemaId
    const clusterCinemaActive = (clusterCinemaOption || currentCinemaType === MULTICINEMA) && currentCinemaId === activeCinema ? true : false

    if((clusterCinemaOption && !clusterCinemaActive) || (currentCinemaType === MULTICINEMA && !clusterCinemaActive)) {
        cinemaFilteredPerformances = _.filter(purchaseblePerformances, performance => {
            const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
            if(isCurrentPerformance(today, performanceDate)) {
                return performance.cinema === activeCinema
            }
        })
    }

    if((clusterCinemaOption && !clusterCinemaActive) || (currentCinemaType === MULTICINEMA && !clusterCinemaActive)) {
        cinemaFilteredPerformances = _.filter(purchaseblePerformances, performance => {
            const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
            if(isCurrentPerformance(today, performanceDate)) {
                return performance.cinema === activeCinema
            }
        })
    }
    
    const containsIgnoredAttributes = getContainsIgnoredAttributes(technologyAttributes)
    
    let timefilteredPerformance = queryStringValues ? filterPerformancesDateFilter(cinemaFilteredPerformances, queryStringValues, today, timezone, dayFilters, locale, overviewFilterIgnoreOnPerformances) : cinemaFilteredPerformances
    let fullyfilteredPerformance = queryStringValues || (filterType && filterValue) ? filterPerformancesQueryStringValues(timefilteredPerformance, queryStringValues, overviewFilterIgnoreOnPerformances, containsIgnoredAttributes, filterType, filterValue) : timefilteredPerformance

    return {
        purchaseblePerformances: purchaseblePerformances,
        fullyfilteredPerformance: fullyfilteredPerformance
    }
}

export default getFullyFilteredPerformances